import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
// THIS IMPORT MUST STAY ABOVE THE App IMPORT. Do not let a formatter or an
// import sorter move it.
//
// In plain words: when somebody clicks the reset link in their email, the proof that they
// did is in the URL, and the Supabase library erases it within milliseconds of reading the
// tokens out of it. This module takes its snapshot of the URL the moment it is evaluated,
// so it has to be evaluated before anything that can reach the Supabase client. Importing
// App first would pull that client in and lose the evidence (FR-005).
import "./services/auth/recovery";
// The Sentry settings live in their own file so they can be tested without starting the
// app. They strip the recovery token out of every URL Sentry reports, and they leave
// session replay off on the reset page (FR-011). See src/lib/sentry-options.ts.
import { sentryOptions } from "./lib/sentry-options";
import App from "./App.tsx";
import "./index.css";

Sentry.init(sentryOptions);

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please refresh.</p>}>
    <App />
  </Sentry.ErrorBoundary>
);
